import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViolationHistoryModalComponent } from './violation-history-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ViolationsService } from '../../../../services/violations/violations.service';
import { NewlineToBreakPipeModule } from '../../../../pipes/format/nl2br.module';
import { NewlineToBreakPipe } from '../../../../pipes/format/nl2br.pipe';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        NewlineToBreakPipeModule,
    ],
    declarations: [ViolationHistoryModalComponent],
    exports: [ViolationHistoryModalComponent],
    providers: [
        ViolationsService,
        NewlineToBreakPipe,
    ],
})
export class ViolationHistoryModalModule
{
}
